/* REFONTE 2026-10-21 (lot 3, chantier 6) : suggestions avant la frappe (snippets/predictive-search-suggest).
 * - Mémorise la fiche produit consultée (localStorage sc_recently_viewed : 6 au plus, le plus récent en premier,
 *   lecture et écriture dans un try/catch ; navigation privée ou stockage bloqué : rien n'est affiché).
 * - Affiche « Vus récemment » + « Tendances » quand la recherche de l'en-tête est ouverte et que le champ est vide ;
 *   les masque dès la frappe (predictive-search.js et strict-search.js ne sont pas modifiés).
 * - « Effacer » vide la liste (annoncé aux lecteurs d'écran).
 * - Lot 2 mobile 25/10 (m-07) : recherche sans aucun résultat (ni produit, ni collection, ni page) : le message de la
 *   recherche prédictive est repris en tête du panneau et « Vus récemment » + « Tendances » restent affichés comme rebond
 *   (avant : écran blanc sous un message de 11 px). Le panneau se met à jour à l'arrivée des résultats.
 * Retour arrière : retirer le rendu de predictive-search-suggest dans snippets/search-header.liquid.
 */
(function () {
  'use strict';
  if (window.scSearchSuggest) return;
  window.scSearchSuggest = true;

  var KEY = 'sc_recently_viewed';
  var MAX = 6;

  function load() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (p) { return p && typeof p.h === 'string' && p.h; }) : [];
    } catch (e) { return []; }
  }
  function save(list) {
    try {
      if (!list.length) window.localStorage.removeItem(KEY);
      else window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) { /* stockage indisponible */ }
  }

  /* 1. Fiche produit : mémorisation */
  function remember() {
    var el = document.querySelector('script[data-sc-recent-current]');
    if (!el) return;
    var p;
    try { p = JSON.parse(el.textContent); } catch (e) { return; }
    if (!p || !p.h) return;
    var list = load().filter(function (x) { return x.h !== p.h; });
    list.unshift({ h: String(p.h), t: String(p.t || ''), b: String(p.b || ''), i: String(p.i || '') });
    save(list);
  }

  /* 2. Panneau */
  function init() {
    remember();
    var box = document.querySelector('[data-sc-suggest]');
    var input = document.getElementById('Search-In-Modal');
    var parent = document.querySelector('.js-search-parent');
    if (!box || !input || !parent) return;
    var recent = box.querySelector('[data-sc-recent]');
    var listEl = box.querySelector('[data-sc-recent-list]');
    var status = box.querySelector('[data-sc-recent-status]');
    var inner = box.querySelector('.sc-suggest__inner') || box;
    var emptyEl = document.createElement('p');
    emptyEl.className = 'sc-suggest__empty';
    emptyEl.hidden = true;
    inner.insertBefore(emptyEl, inner.firstChild);
    var root = box.getAttribute('data-root') || '';
    var strings = {};
    try { strings = JSON.parse(document.querySelector('script[data-sc-search-i18n]').textContent) || {}; } catch (e) { strings = {}; }

    function render() {
      var items = load();
      listEl.textContent = '';
      items.forEach(function (p) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'sc-suggest__item';
        a.href = root + '/products/' + encodeURIComponent(p.h);
        var media = document.createElement('span');
        media.className = 'sc-suggest__media';
        if (p.i && /^(https?:)?\/\//.test(p.i)) {
          var img = document.createElement('img');
          img.src = p.i;
          img.alt = '';
          img.width = 120;
          img.height = 150;
          img.loading = 'lazy';
          img.decoding = 'async';
          media.appendChild(img);
        }
        a.appendChild(media);
        if (p.b) {
          var b = document.createElement('span');
          b.className = 'sc-suggest__brand';
          b.textContent = p.b;
          a.appendChild(b);
        }
        var t = document.createElement('span');
        t.className = 'sc-suggest__name';
        t.textContent = p.t || p.h;
        a.appendChild(t);
        li.appendChild(a);
        listEl.appendChild(li);
      });
      recent.hidden = items.length === 0;
    }

    /* Texte du message « aucun résultat » quand la recherche prédictive ne propose aucun lien ; sinon chaîne vide. */
    function noResultText() {
      var res = document.getElementById('predictive-search-results');
      if (!res || res.querySelector('a[href]')) return '';
      var msg = res.querySelector('.sc-ps-empty');
      return msg ? msg.textContent.trim() : '';
    }

    function update() {
      var open = parent.classList.contains('is-open');
      var q = input.value.trim();
      var empty = open && q ? noResultText() : '';
      var show = open && (!q || !!empty);
      if (emptyEl.textContent !== empty) emptyEl.textContent = empty;
      emptyEl.hidden = !empty;
      if (show && box.hidden) render();
      box.hidden = !show;
    }

    if (window.MutationObserver) {
      new MutationObserver(update).observe(parent, { attributes: true, attributeFilter: ['class'] });
      var ps = parent.querySelector('[data-predictive-search]');
      if (ps) new MutationObserver(update).observe(ps, { childList: true, subtree: true });
    }
    input.addEventListener('input', update);
    input.addEventListener('focus', update);
    box.addEventListener('click', function (e) {
      if (!e.target.closest('[data-sc-recent-clear]')) return;
      e.preventDefault();
      e.stopPropagation();
      save([]);
      render();
      if (status) status.textContent = strings.cleared || '';
      input.focus({ preventScroll: true });
    });
    update();
  }

  /* 3. Correctif 25/10 (agent-correctifs, RGAA 10.7) : flèches haut et bas de la recherche prédictive.
   * predictive-search.js parcourait tous les <li> du panneau : les collections (sans rôle ni id) passaient en
   * aria-selected avec un aria-activedescendant vide, et la flèche bas tournait en boucle sur elles sans atteindre les
   * produits. Ici, seules les options visibles (role=option avec un id) sont parcourues : produits, puis « Voir tous les
   * produits ». L'option choisie porte aria-selected="true", le champ aria-activedescendant = son id ; elle est ramenée
   * dans la partie visible du panneau et annoncée par la zone de statut (même texte qu'avant). Entrée et Échap : inchangés
   * (predictive-search.js). Le repère visuel est dans refonte-search.css. */
  function initOptions() {
    var input = document.getElementById('Search-In-Modal');
    var ps = input && input.closest('predictive-search');
    if (!ps || ps.__scOptions) return;
    ps.__scOptions = true;
    var status = ps.querySelector('.predictive-search-status');

    function options() {
      return Array.prototype.slice.call(ps.querySelectorAll('[role="option"][id]')).filter(function (o) {
        return o.getClientRects().length > 0;
      });
    }

    ps.addEventListener('keyup', function (event) {
      if (event.code !== 'ArrowDown' && event.code !== 'ArrowUp') return;
      // Remplace la navigation de predictive-search.js (écouteur posé sur ce même élément, en phase de remontée).
      event.stopPropagation();
      event.preventDefault();
      if (!ps.hasAttribute('open')) return;
      var list = options();
      if (!list.length) return;
      var current = ps.querySelector('[aria-selected="true"]');
      var i = list.indexOf(current);
      var next;
      if (event.code === 'ArrowDown') {
        next = list[i + 1] || list[0];
      } else {
        if (!current) return;
        next = i > 0 ? list[i - 1] : list[list.length - 1];
      }
      Array.prototype.forEach.call(ps.querySelectorAll('[aria-selected="true"]'), function (o) {
        if (o !== next) o.setAttribute('aria-selected', 'false');
      });
      next.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', next.id);
      try { next.scrollIntoView({ block: 'nearest' }); } catch (e) { /* navigateur ancien */ }
      if (status) status.textContent = (next.textContent || '').replace(/\s+/g, ' ').trim();
    }, true);

    // Résultats remplacés à la frappe : aria-activedescendant ne doit pas viser une option absente ou non choisie.
    var results = ps.querySelector('[data-predictive-search]');
    if (results && window.MutationObserver) {
      new MutationObserver(function () {
        var id = input.getAttribute('aria-activedescendant');
        if (!id) return;
        var o = document.getElementById(id);
        if (!o || !ps.contains(o) || o.getAttribute('aria-selected') !== 'true') input.setAttribute('aria-activedescendant', '');
      }).observe(results, { childList: true, subtree: true });
    }
  }

  function start() { init(); initOptions(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
